<template>
    <Box :hideable="true">
        <h3 slot="header">
            <i class="fa fa-filter"></i> {{resource('AnalysisSelection_Index_Filter_Header')}}
        </h3>
        <div slot="body">
            <div class="grid-container filter">
                <filter-item icon="far fa-calendar-alt" :label="resource('AnalysisSelectionFilterModel_StartDate_DisplayName')">
                    <DatePicker
                        class="form-control"
                        v-model="filters.startDate"
                        :options="startOptions"
                    />
                </filter-item>
                
                <filter-item icon="far fa-calendar-alt" :label="resource('AnalysisSelectionFilterModel_EndDate_DisplayName')">
                    <date-picker
                        class="form-control"
                        v-model="filters.endDate"
                        :options="endOptions"
                    />
                </filter-item>

                <filter-item icon="fas fa-phone-alt" :label="resource('AnalysisSelectionFilterModel_DivisionId_DisplayName')">
                    <division-dropdown
                        v-if="divisions"
                        v-model="filters.divisionId"
                        :division-list="divisions"

                        @input="setDropDowns($event)"
                    />
                </filter-item>

                <filter-item icon="fas fa-user" :label="resource('AnalysisSelectionFilterModel_AgentId_DisplayName')">
                    <dropdown
                        v-model="filters.agentId"
                        :datasource="agents"
                        :placeholder="resource('AnalysisSelection_Index_Filters_Agent_Placeholder')"
                    />
                </filter-item>

                <filter-item v-if="hasOffers" icon="fas fa-clipboard-list" :label="resource('AnalysisSelectionFilterModel_OfferId_DisplayName')">
                    <dropdown
                        v-model="filters.offerId"
                        :datasource="offers"
                        :placeholder="resource('AnalysisSelection_Index_Filters_Offer_Placeholder')"
                    />
                </filter-item>

                <filter-item v-if="hasSuppliers" icon="fas fa-truck" :label="resource('AnalysisSelectionFilterModel_SupplierId_DisplayName')">
                    <dropdown
                        v-model="filters.supplierId"
                        :datasource="suppliers"
                        :placeholder="resource('AnalysisSelection_Index_Filters_Supplier_Placeholder')"
                    />
                </filter-item>

                <filter-item v-if="hasContractTypes" icon="fas fa-file-signature" :label="resource('AnalysisSelectionFilterModel_ContractTypeId_DisplayName')">
                    <dropdown
                        v-model="filters.contractTypeId"
                        :datasource="contractTypes"
                        :placeholder="resource('AnalysisSelection_Index_Filters_ContractType_Placeholder')"
                    />
                </filter-item>

                <filter-item icon="far fa-check-circle" :label="resource('AnalysisSelectionFilterModel_Sale_DisplayName')">
                    <dropdown
                        v-model="filters.sale"
                        :datasource="saleDatasource"
                        :placeholder="resource('AnalysisSelection_Index_Filters_Sale_Placeholder')"
                    />
                </filter-item>

                <div class="grid-item-bottom-right">
                    <button ref="searchBtn" class="btn btn-primary" @click="filter">
                        <i class="fa fa-search"></i> {{resource('Button_Search')}}
                    </button>
                </div>

            </div>

        </div>
    </Box>
</template>

<script>

import $ from 'jquery';
import moment from 'moment';
import _ from 'lodash';

//Api
import api from '../api';
import divisionApi from '../../../../../Core/Api/divisions';
import growler from '../../../../../Core/Util/growler';

//Mixins
import guidMixin from '../../../../../Core/Util/Mixins/guid';
import resourceMixin from '../../../../../Core/Util/Mixins/resources';

//Components
import BootstrapBox from '../../../../../Core/Components/Util/BootstrapBox.vue';
import DatePicker from '../../../../../Core/Components/Util/DatePicker.vue';
import DivisionDropdown from '../../../../../Core/Components/Util/DivisionDropdown.vue';
import Dropdown from '../../../../../Core/Components/Inputs/Dropdown.vue';
import FilterItem from './FilterItem.vue'

let enabledDivisionsProm;
let agentsProm;

export default {
    name: 'analysis-selection-filter',
    mixins: [guidMixin, resourceMixin],
    components: {
        'Box': BootstrapBox,
        DatePicker,
        DivisionDropdown,
        Dropdown,
        FilterItem
    },
    beforeCreate() {
        const vm = this;

        (enabledDivisionsProm || (enabledDivisionsProm = divisionApi.getDivisionsList({includeDisabled: true})))
        .then(
            divisions => { vm.divisions = divisions; },
            growler.bootstrapDanger
        );
    },
    created() {
        this.calls = this.value;  
    },
    methods: {
        filter() {
            const vm = this;            
            vm.setLoading('loading');

            api.filter(vm.filters).then(
                calls => { 
                    vm.calls = calls;
                    vm.setLoading('done');
                },
                error => { //Service returned errors
                    growler.bootstrapDanger(error);
                    vm.setLoading('done');
                }
            );
        },
        setLoading(value) {
            const vm = this;
            vm.$emit(value);
            $(vm.$refs.searchBtn).prop('disabled', value === 'done' ? false : true);
        },
        setDropDowns(divisionId) {
            const vm = this;

            api.getAgents(divisionId).then(
                agents => { vm.agents = agents; },
                growler.bootstrapDanger
            );
            api.getOffers(divisionId).then(
                offers => { vm.offers = offers; },
                growler.bootstrapDanger
            );
            api.getSuppliers(divisionId).then(
                suppliers => { vm.suppliers = suppliers; },
                growler.bootstrapDanger
            );
            api.getContractTypes(divisionId).then(
                contractTypes => { vm.contractTypes = contractTypes; },
                growler.bootstrapDanger
            );
        }
    },
    computed: {
        startOptions() {
            const vm = this;
            return _.merge(
                {},
                vm.datepickerOptions,
                { id: vm.startElementId, name: vm.startElementId }
            );
        },
        endOptions() {
            const vm = this;
            return _.merge(
                {},
                vm.datepickerOptions,
                { id: vm.endElementId, name: vm.endElementId }
            );
        },
        saleDatasource() {
            return [
                    {text: this.resource('Bool_Yes'), value: 'true'},
                    {text: this.resource('Bool_No'), value: 'false'}
                ];
        },
        hasOffers() {
            return this.offers.length > 0;
        },
        hasSuppliers() {
            return this.suppliers.length > 0;
        },
        hasContractTypes() {
            return this.contractTypes.length > 0;
        }
    },
    watch: {
        calls(value) {
            if(value != this.value) {
                this.$emit('input', value);
            }
        }
    },
    data() {
        const vm = this;
        const minDate = new Date();
        minDate.setDate(minDate.getDate()-90);

        return {
            filters: {
                startDate: new Date(),
                endDate: new Date(),
                divisionId: null,
                agentId: null,
                offerId: null,
                supplierId: null,
                contractTypeId: null,
                sale: null
            },
            datepickerOptions: {
                disabledDates: {
                    to: minDate,
                    from: new Date()
                },
                required: true,
                typeable: false
            },
            divisions: null,
            agents: [],
            offers: [],
            suppliers: [],
            contractTypes: [],
            calls: null
        };
    },
    props: {
        value: {
            type: Array,
            required: true
        }
    }
};
</script>


<style lang="scss" scoped src="../Style/analysis-selection.scss">

</style>